import React, { useState ,useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import Seo from "../components/Seo";

function TrustSidebar() {
  return (
    <aside className="hidden lg:flex flex-col gap-6 sticky top-24" data-testid="auth-trust-sidebar">
      <div className="aspect-[4/5] overflow-hidden rounded-[12px] border-[0.5px] border-black/10">
        <img src="https://images.unsplash.com/photo-1779272987047-1e21f36fc821" alt="Studio" className="w-full h-full object-cover"/>
      </div>
      <div className="card">
        <div className="font-serif text-lg mb-3">A few promises</div>
        <ul className="text-sm space-y-2 text-black/70">
          <li>· Passwords are secured.</li>
          <li>· Email never sold.</li>
          <li>· Delete account any time.</li>
        </ul>
      </div>
    </aside>
  );
}

export function SignIn() {
  const { login , user} = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [err, setErr] = useState(""); const [loading, setLoading] = useState(false);


   useEffect(() => {
    if (user) {
      nav(loc.state?.from || "/dashboard", { replace: true });
    }
  }, [user, nav, loc.state]);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { toast.success("Welcome back"); nav(loc.state?.from || "/dashboard"); }
    else setErr(r.error);
  };

  return (
    <div className="container-x py-16 grid lg:grid-cols-2 gap-12 max-w-5xl">
      <Seo title="Sign in" noindex/>
      <div className="max-w-md w-full">
        <h1 className="font-serif text-4xl">Sign in</h1>
        <p className="text-sm text-black/60 mt-2">Welcome back to Inkstead.</p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="signin-form">
          <div>
            <label className="text-sm font-medium block mb-1.5">Email</label>
            <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="you@studio.com" className="input-field" data-testid="signin-email"/>
          </div>
          <div>
            <label className="text-sm font-medium block mb-1.5">Password</label>
            <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="••••••••" className="input-field" data-testid="signin-password"/>
          </div>
          {err && <div className="text-sm text-red-700" data-testid="signin-error">{err}</div>}
          <button type="submit" className="btn-filled w-full" disabled={loading} data-testid="signin-submit">{loading ? "Signing in..." : "Sign in"}</button>
          <button type="button" className="btn-outline w-full" disabled data-testid="signin-google">Continue with Google (coming soon)</button>
          <div className="flex justify-between text-sm pt-2">
            <Link to="/forgot-password" className="underline underline-offset-4" data-testid="signin-forgot">Forgot password?</Link>
            <Link to="/sign-up" className="underline underline-offset-4" data-testid="signin-signup">Create an account</Link>
          </div>
        </form>
      </div>
      {/* <TrustSidebar/> */}
    </div>
  );
}

export function SignUp() {
  const { register ,user} = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "", name: "", account_type: "client" });
  const [err, setErr] = useState(""); const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (user) {
      nav(loc.state?.from || "/dashboard", { replace: true });
    }
  }, [user, nav, loc.state]);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    const r = await register(form);
    setLoading(false);
    if (r.ok) { toast.success("Welcome to Inkstead"); nav("/dashboard"); }
    else setErr(r.error);
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="container-x py-16 grid lg:grid-cols-2 gap-12 max-w-5xl">
      <Seo title="Create your account" noindex/>
      <div className="max-w-md w-full">
        <h1 className="font-serif text-4xl">Create your account</h1>
        <p className="text-sm text-black/60 mt-2">Choose how you'll show up.</p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="signup-form">
          <div>
            <label className="text-sm font-medium block mb-2">I am</label>
            <div className="grid grid-cols-2 gap-3">
              {["client", "artist"].map((t) => (
                <button type="button" key={t}
                  onClick={() => setForm({ ...form, account_type: t })}
                  className={`p-4 rounded-[8px] text-left border-[0.5px] ${form.account_type === t ? "border-black bg-black text-white" : "border-black/20"}`}
                  data-testid={`signup-type-${t}`}>
                  <div className="font-medium capitalize">{t}</div>
                  <div className={`text-xs mt-1 ${form.account_type===t?"text-white/70":"text-black/60"}`}>
                    {t === "artist" ? "I tattoo people" : "I get tattooed"}
                  </div>
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="text-sm font-medium block mb-1.5">Display name</label>
            <input required value={form.name} onChange={set("name")} placeholder="Maya Torres" className="input-field" data-testid="signup-name"/>
          </div>
          <div>
            <label className="text-sm font-medium block mb-1.5">Email</label>
            <input type="email" required value={form.email} onChange={set("email")} placeholder="you@studio.com" className="input-field" data-testid="signup-email"/>
          </div>
          <div>
            <label className="text-sm font-medium block mb-1.5">Password</label>
            <input type="password" required minLength={6} value={form.password} onChange={set("password")} placeholder="At least 6 characters" className="input-field" data-testid="signup-password"/>
          </div>
          {err && <div className="text-sm text-red-700" data-testid="signup-error">{err}</div>}
          <button type="submit" className="btn-filled w-full" disabled={loading} data-testid="signup-submit">{loading ? "Creating..." : "Create account"}</button>
          <button type="button" className="btn-outline w-full" disabled data-testid="signup-google">Continue with Google (coming soon)</button>
          <p className="text-xs text-black/50 pt-2">By signing up you agree to be kind, credit artists, and keep it weird.</p>
        </form>
      </div>
      {/* <TrustSidebar/> */}
    </div>
  );
}

export function ForgotPassword() {
  const [email, setEmail] = useState(""); const [msg, setMsg] = useState(""); const [token, setToken] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await (await import("../lib/api")).api.post("/auth/forgot-password", { email });
      setMsg("If that account exists, a reset link has been generated.");
      if (r.data.dev_token) setToken(r.data.dev_token);
    } catch { setMsg("Something went wrong"); }
  };
  return (
    <div className="container-x py-16 max-w-md">
      <Seo title="Forgot password" noindex/>
      <h1 className="font-serif text-4xl">Forgot password</h1>
      <p className="text-sm text-black/60 mt-2">We'll create a reset link. Email delivery is configurable — for development the token is shown below.</p>
      <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
        <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="you@studio.com" className="input-field" data-testid="forgot-email"/>
        <button className="btn-filled w-full" data-testid="forgot-submit">Send reset link</button>
      </form>
      {msg && <p className="text-sm text-black/70 mt-4" data-testid="forgot-msg">{msg}</p>}
      {token && <div className="card mt-4 break-all text-xs" data-testid="forgot-dev-token"><div className="font-medium mb-1">Dev token:</div>{token}</div>}
    </div>
  );
}
